module.exports = __webpack_public_path__ + "media/images/top/feature03-44bcba3d95d4cb8f0781f063deeab714.jpg";